/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Ce } from './Ce';

const { GlobalVar } = Utils;

class AdmitCardTemplate extends Ce {
    constructor() {
        super();
        this.baseUrl += '/admitCardTemplate';
    }

    data({ templateName, currentPage, pageSize } = {}) {
        return super.get('/data', {
            templateName,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { templateFile } = json.data.data;
            if (!templateFile) {
                json.data.data.templateFile = [];
            } else {
                json.data.data.templateFile = templateFile.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({ id, templateName, templateFile, templateDesc, remarks } = {}) {
        const templateFileStr = templateFile
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            templateName,
            templateDesc,
            remarks,
            templateFile: templateFileStr,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    select() {
        return super.get('/select', {});
    }
}

export default new AdmitCardTemplate();
export { AdmitCardTemplate };
